<app-header
  [showBackButton]="true"
  [headerData]="headerDataValues"
  [defaultBackUrl]="defaultBackUrl"
  class="full"
></app-header>
<app-offline-mode></app-offline-mode>

<ion-content>
  <app-filling-rts-progress
    *ngIf="!loading"
    [totalWeight]="request.requestedWeightInTons"
    [assignedWeight]="calcAssignedWeight()"
  ></app-filling-rts-progress>
  <app-document-shelf
    *ngIf="!loading"
    [bargainId]="request.bargainId"
    [refreshSignal]="shelfRefreshSignal"
  ></app-document-shelf>

  <div *ngIf="loading" class="main-loader">
    <div class="skeleton">
      <ion-skeleton-text
        style="height: 79px; width: 90%"
        [animated]="true"
      ></ion-skeleton-text>
      <ion-skeleton-text
        style="height: 79px; width: 90%"
        [animated]="true"
      ></ion-skeleton-text>
      <ion-skeleton-text
        style="height: 79px; width: 90%"
        [animated]="true"
      ></ion-skeleton-text>
    </div>

    <div class="skeleton-footer">
      <div class="skeleton-wrapper">
        <div class="skeleton-block">
          <ion-skeleton-text
            style="height: 10px; width: 120px"
            [animated]="true"
          ></ion-skeleton-text>
          <ion-skeleton-text
            style="height: 10px; width: 65%"
            [animated]="true"
          ></ion-skeleton-text>
          <ion-skeleton-text
            style="height: 10px; width: 50px"
            [animated]="true"
          ></ion-skeleton-text>
        </div>

        <div class="skeleton-block">
          <ion-skeleton-text
            style="height: 10px; width: 250px"
            [animated]="true"
          ></ion-skeleton-text>
          <ion-skeleton-text
            style="height: 10px; width: 150px"
            [animated]="true"
          ></ion-skeleton-text>
        </div>

        <div class="skeleton-block">
          <ion-skeleton-text
            style="height: 10px; width: 120px"
            [animated]="true"
          ></ion-skeleton-text>
          <ion-skeleton-text
            style="height: 10px; width: 80px"
            [animated]="true"
          ></ion-skeleton-text>
        </div>
      </div>
    </div>
  </div>

  <!-- Три разных причины пустого реестра — три разных сообщения. Раньше все они выглядели как сбой связи,
       хотя чаще всего заявка просто ждёт перевозчика. -->
  <ng-container *ngIf="carrierNotAssigned">
    <div class="no-rts-wrapper waiting-wrapper">
      <div class="title">Перевозчик ещё не назначен</div>
      <img src="../../../assets/images/no-content.svg" alt/>
      <div class="note-wrapper">
        <div class="title">Заявка на перевозку размещена.</div>
        <div class="text">
          Реестр появится, когда перевозчик возьмёт заявку и подаст машины.
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="noVehiclesYet">
    <div class="no-rts-wrapper waiting-wrapper">
      <div class="title">Машины ещё не поданы</div>
      <img src="../../../assets/images/no-content.svg" alt/>
      <div class="note-wrapper">
        <div class="title">Перевозчик назначен.</div>
        <div class="text">
          Реестр наполнится, когда перевозчик подаст машины на дату отгрузки.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Состояние перевозчика неизвестно: связи нет, заявка вне сделки или контур снят. Утверждать про
       интернет здесь нельзя — ответ мог прийти и быть исправным. -->
  <ng-container *ngIf="rtsUnavailable">
    <div class="no-rts-wrapper">
      <div class="title">Реестр пока недоступен</div>
      <img src="../../../assets/images/no-rts-modal.svg" alt/>
      <div class="note-wrapper">
        <div class="title">РТС по этой заявке отсутствует.</div>
        <div class="text">
          Потяните экран вниз, чтобы обновить. Если связи нет, реестр загрузится после её восстановления.
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="request?.status !== 'OPEN'">
    <ion-refresher
      [disabled]="isRefresherDisabled && loading"
      class="refresher"
      slot="fixed"
      (ionRefresh)="handleRefresh($event)"
    >
      <ion-refresher-content pullingIcon refreshingSpinner="lines">
      </ion-refresher-content>
    </ion-refresher>

    <!-- Список дней — только когда в реестре есть машины: иначе на экране стояло бы объяснение
         состояния и тут же карточки дней-скелетов, открывать которые нечем. -->
    <ng-container *ngIf="daysVisible">
      <ion-item
        class="item ion-no-padding"
        *ngFor="let item of daysList; index as i"
        button="true"
        mode="md"
        (click)="openDayDetails(item.orderNumber)"
      >
        <div class="item-container">
          <div class="icon">
            <ion-icon
              class="checkmark"
              src="../../../assets/icon/checked-icon.svg"
              *ngIf="item.completed; else unchecked"
            ></ion-icon>
            <ng-template #unchecked>
              <ion-icon
                class="checkmark"
                src="../../../assets/icon/unchecked-icon.svg"
              ></ion-icon>
            </ng-template>
          </div>

          <div class="day-info">
            <div class="day-details">
              <div>
                <div class="day-number">День {{ i + 1 }}</div>
                <div class="shipment-day">
                  {{ item.shipmentDate.split(' ')[0] }}
                </div>
              </div>

              <div>
                <div *ngIf="item.vehicles?.length" class="car-amount">
                  Количество машин:
                  <div class="amount">{{ item.vehicles.length }}</div>
                </div>
                <div>
                  <div class="rts-flag red-flag" *ngIf="!item.vehicles?.length">
                    РТС ожидается
                  </div>
                  <div class="rts-flag" *ngIf="item.vehicles?.length">
                    Есть РТС
                  </div>
                </div>
              </div>
              <div>
                <div *ngIf="item.vehicles?.length && !item.started && !item.completed" class="car-amount">
                  Разобрано:
                  <div class="amount">
                  <span class="weight-value">
                    {{ item.vehicles.length * 25 }}
                  </span>
                    т
                  </div>
                </div>

                <div *ngIf="item.vehicles?.length && item.completed || item.started" class="car-amount">
                  Отгружено:
                  <div class="amount">
                  <span class="weight-value">
                    {{ calcLoadedWeight(item) }}
                  </span>
                    кг
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ion-item>
    </ng-container>

    <div *ngIf="!loading && !request.statusIsArchive()" class="contact-info">
      <div>
        <!-- Кто везёт: экспедитор координирует погрузку, и знать перевозчика ему нужно. Пустые значения
             не печатаем — подпись без значения читается как сбой. -->
        <div class="row" *ngIf="request.carrierName">
          <div>
            <strong>
              Перевозчик:
              <span class="smart-number">{{ request.carrierName }}</span>
            </strong>
          </div>
        </div>
        <div class="row" *ngIf="request.transporterOrderId">
          <div>
            <strong>
              Номер заказа перевозчика:
              <span class="smart-number">
                {{ request.transporterOrderId }}
              </span>
            </strong>
          </div>
        </div>
        <div class="row">
          <div>
            <strong>Пункт погрузки:</strong>
          </div>
          <div style="margin-top: 8px">
            {{ request.loading.title }}
          </div>
          <div class="underlined" (click)="copyText(request.loading.address)">
            {{ request.loading.address }}
          </div>
        </div>
        <div class="row">
          <div>
            <strong>Организация:</strong>
          </div>
          <div class="underlined" (click)="copyText(request.seller.orgName)">
            {{ request.seller.orgName }}
          </div>
        </div>
        <div class="row">
          <div>
            <strong>Контакты:</strong>
          </div>
          <div *ngIf="request.seller.phone">
            <a class="phone" [attr.href]="phoneHref">
              {{ request.seller.phone | phoneNumber }}
            </a>
          </div>
        </div>
      </div>
      <a
        [href]="'http://maps.apple.com/?q=' + request.loading.address"
        class="location-section"
      >
        <ion-button
          class="light square ion-activatable ion-selectable ion-focusable"
          mode="md"
        >
          <ion-icon
            class="location"
            src="../../../assets/icon/location-icon.svg"
          ></ion-icon>
        </ion-button>
      </a>
    </div>

    <div class="accept-order-block" *ngIf="!loading && showEndOrderBlock">
      <ion-button (click)="endOrder()" class="primary large" mode="md">
        Завершить заявку
      </ion-button>
    </div>

    <div
      *ngIf="
        !loading &&
        request.statusIsArchive() &&
        !request?.unloadedDeliveryInfo?.unloadedWeight
      "
      class="archive-footer-wrapper"
    >
      <div class="wait-data-banner">
        <div class="title">Ожидаем данные по выгрузке</div>

        <div class="spiner-wrapper">
          <img src="assets/icon/big-spiner.svg" alt/>
        </div>

        <div class="unload-location-note">
          <span class="note-title">Пункт разгрузки:</span>
          <span class="address">{{ request.unloading.title }}</span>
          <span class="address">{{ request.unloading.address }}</span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      !loading &&
      request.statusIsArchive() &&
      request?.unloadedDeliveryInfo?.unloadedWeight
    "
  >
    <div class="archive-footer-wrapper">
      <div class="additional-button-wrapper">
        <div
          class="download-button"
          [class.disabled]="isDownloadingReport"
          (click)="!isDownloadingReport && downloadForwarderReport()"
          (keyup.enter)="!isDownloadingReport && downloadForwarderReport()"
          (keydown.space)="!isDownloadingReport && downloadForwarderReport()"
          tabindex="0"
          role="button"
          aria-label="Отчет экспедитора"
        >
          <div class="button-content">
            <img *ngIf="!isDownloadingReport" src="assets/icon/download-file-icon.svg" alt="download icon"/>
            <ion-spinner *ngIf="isDownloadingReport" name="lines" class="download-spinner"></ion-spinner>
            <span>{{ isDownloadingReport ? 'Скачивание...' : 'Отчет экспедитора' }}</span>
          </div>
        </div>
      </div>
      <div class="additional-button-wrapper">
        <div
          class="download-button"
          (click)="openUploadDocuments()"
          (keyup.enter)="openUploadDocuments()"
          (keydown.space)="openUploadDocuments()"
          tabindex="0"
          role="button"
          aria-label="Загрузить итоговые документы"
        >
          <div class="button-content">
            <img src="assets/icon/upload-file-icon.svg" alt="upload icon"/>
            <span>Загрузить итоговые документы</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ion-content>

<ion-toast
  [isOpen]="isToastOpen"
  message="Скопировано"
  [duration]="3000"
  (didDismiss)="toastSetStatus(false)"
  [animated]="true"
></ion-toast>
